'use client'

import { clsx } from 'clsx'
import { type FC, useRef } from 'react'

import { useParseVideoStrings } from './useParseVideoStrings'

export const ProductDescriptionParsedField: FC<{
  className?: string
  field: string
}> = ({ className, field }) => {
  const parsedField = useParseVideoStrings(field)

  const wrapperElementRef = useRef<HTMLDivElement | null>(null)

  return (
    <div
      className={clsx('prose mb-3.5 whitespace-normal text-s', className)}
      // eslint-disable-next-line react/no-danger -- the data is sanitized on server side
      dangerouslySetInnerHTML={{ __html: parsedField }}
      ref={wrapperElementRef}
    />
  )
}
